import {useContext} from 'react'
import {DynamicTable} from '../../../../components/DynamicTable'
import {BRAND_REPORT_COLUMNS, parseBrandReportRow} from '../../utils'
import {BrandReportContext} from '../../context'
import BrandReportRow from './BrandReportRow'

const BrandReportTable = () => {
  const {reportData, isLoading, filters, onSortingChange} = useContext(BrandReportContext)

  return (
    <div className='sticky-table-wrapper'>
      <div className='table-responsive-wrapper'>
        <div className='table-responsive'>
          <DynamicTable
            data={reportData}
            sortableColumns={BRAND_REPORT_COLUMNS}
            loading={isLoading}
            TableRow={BrandReportRow}
            noDataMessage='No brand reports found'
            filters={filters}
            onSortingChange={onSortingChange}
            tableClass='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-2'
            tableHeaderClass='sticky-table-header'
            rowParsingFunction={parseBrandReportRow}
          />
        </div>
      </div>
    </div>
  )
}

export default BrandReportTable
